import cn from 'classnames';
import Header from '../header/header';
import Footer from '../footer/footer';
import ScrollButton from '../scroll-to-top/scroll-to-top';
import Cookie from '../cookie/cookie';
import styles from './cookie-page.module.scss';

function CookiePage() {
	return (
		<div className={styles.wrapper}>
			<Header />
			<main>
				<div className={cn(styles.privacy, 'container')}>
					<h1 className={styles.title}>Правила использования файлов cookie на сайте ООО «ДАНТИСТ плюс»</h1>
					<p>Дата обновления: 01.01.2026</p>
					<h2 className={styles.subtitle}>1. Общие положения</h2>
					<p>1.1. Настоящие Правила использования файлов cookie (далее — Правила) определяют порядок обработки файлов cookie и связанных с ними технических данных при использовании сайта ООО «ДАНТИСТ плюс» (далее — Оператор, Сайт).</p>
					<p>1.2. Оператором, осуществляющим обработку данных в связи с использованием Сайта, является: Общество с ограниченной ответственностью «ДАНТИСТ плюс», ИНН 5036071357, ОГРН 1065074050788, адрес местонахождения 142117, Московская обл., г.Подольск, ул.Кирова, д.61, помещ. 1, адрес электронной почты для обращений субъектов персональных данных dant.plus@yandex.ru, телефон 8 965 197 80 20.</p>
					<p>1.3. Настоящие Правила разработаны в соответствии с законодательством Российской Федерации, включая Федеральный закон от 27.07.2006 № 152-ФЗ «О персональных данных», и применяются совместно с Политикой конфиденциальности ООО «ДАНТИСТ плюс» в отношении обработки персональных данных. Обязанность оператора опубликовать политику или иным образом обеспечить к ней неограниченный доступ установлена ст. 18.1 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных».</p>
					<p>1.4. Продолжая использование Сайта, пользователь выражает согласие ООО «ДАНТИСТ плюс» на обработку файлов cookie и связанных технических данных в порядке и на условиях, изложенных в настоящих Правилах, если иное не предусмотрено законодательством Российской Федерации.</p>
					<h2 className={styles.subtitle}>2. Что такое cookie</h2>
					<p>2.1. Файлы cookie — это небольшие фрагменты данных, которые направляются веб-сервером и сохраняются на устройстве пользователя при посещении Сайта.</p>
					<p>2.2. Cookie могут содержать:</p>
					<ul>
						<li>сведения о пользовательских настройках;</li>
						<li>идентификаторы сессии;</li>
						<li>сведения о действиях пользователя на Сайте;</li>
						<li>технические параметры устройства и браузера;</li>
						<li>иные технические данные, необходимые для корректной работы Сайта и анализа его использования.</li>
					</ul>
					<p>2.3. В зависимости от контекста использования cookie и связанные с ними технические данные могут относиться к персональным данным, если позволяют прямо или косвенно определить пользователя. Понятие персональных данных и требования к согласию закреплены в Федеральном законе от 27.07.2006 № 152-ФЗ «О персональных данных».</p>
					<h2 className={styles.subtitle}>3. Какие данные могут обрабатываться</h2>
					<p>При использовании Сайта Оператор может обрабатывать следующие технические данные:</p>
					<ul>
						<li>IP-адрес;</li>
						<li>тип устройства;</li>
						<li>тип и версия браузера;</li>
						<li>сведения об операционной системе;</li>
						<li>язык браузера;</li>
						<li>источник перехода на Сайт;</li>
						<li>дата и время посещения;</li>
						<li>адреса запрашиваемых страниц;</li>
						<li>сведения о действиях пользователя на Сайте;</li>
						<li>технические журналы событий;</li>
						<li>cookie-идентификаторы;</li>
						<li>иные аналогичные технические данные.</li>
					</ul>
					<p>3.2. Указанные данные используются отдельно или в совокупности в пределах целей, указанных в разделе 4 настоящих Правил.</p>
					<h2 className={styles.subtitle}>4. Цели использования cookie</h2>
					<p>4.1. Оператор использует cookie и связанные технические данные в следующих целях:</p>
					<ul>
						<li>обеспечение корректной и безопасной работы Сайта;</li>
						<li>сохранение пользовательских настроек;</li>
						<li>обеспечение работы веб-форм и сервисов Сайта;</li>
						<li>анализ посещаемости и использования Сайта;</li>
						<li>улучшение структуры, содержания и функциональности Сайта;</li>
						<li>выявление и устранение технических ошибок;</li>
						<li>защита Сайта от злоупотреблений и недобросовестного использования.</li>
					</ul>
					<p>4.2. Cookie не используются Оператором для принятия юридически значимых решений исключительно на основании автоматизированной обработки данных без участия человека.</p>
					<h2 className={styles.subtitle}>5. Виды используемых cookie</h2>
					<p>5.1. На Сайте могут использоваться следующие категории cookie:</p>
					<ul className={styles.list}>
						<li>5.1.1. Технические (обязательные) cookie
							<p>Необходимы для функционирования Сайта, навигации по страницам, использования основных сервисов и обеспечения безопасности.</p>
						</li>
						<li>5.1.2. Функциональные cookie
							<p>Позволяют запоминать выбор пользователя, сохранять настройки и обеспечивать более удобное использование Сайта.</p>
						</li>
						<li>5.1.3. Аналитические cookie
							<p>Используются для сбора обезличенной или технической информации о посещаемости Сайта, поведении пользователей и эффективности отдельных страниц и сервисов. </p>
						</li>
					</ul>
					<h2 className={styles.subtitle}>6. Использование сервисов веб-аналитики</h2>
					<p>6.1. На Сайте может использоваться сервис веб-аналитики Яндекс.Метрика для анализа использования Сайта, улучшения его работы и оценки востребованности отдельных разделов и сервисов.</p>
					<p>6.2. В рамках работы сервиса веб-аналитики могут обрабатываться технические данные пользователя, включая IP-адрес, сведения об устройстве, браузере, действиях на Сайте, времени посещения страниц и иные технические сведения.</p>
					<p>6.3. Использование сторонних аналитических инструментов осуществляется в соответствии с настоящими Правилами, Политикой конфиденциальности ООО «ДАНТИСТ плюс» в отношении обработки персональных данных, а также документами соответствующего поставщика сервиса.</p>
					<h2 className={styles.subtitle}>7. Срок хранения cookie</h2>
					<p>7.1. Срок хранения cookie зависит от их вида и назначения.</p>
					<p>7.2. Часть cookie действует только в течение сессии пользователя и удаляется после закрытия браузера.</p>
					<p>7.3. Иные cookie могут сохраняться на устройстве пользователя в течение срока, необходимого для достижения целей их использования, либо до момента удаления пользователем cookie в настройках браузера.</p>
					<h2 className={styles.subtitle}>8. Как пользователь может управлять cookie</h2>
					<p>8.1. Пользователь вправе:</p>
					<ul>
						<li>изменить настройки своего браузера и отказаться от сохранения cookie;</li>
						<li>удалить ранее сохраненные cookie; </li>
						<li>ограничить использование отдельных категорий cookie, если соответствующий функционал реализован на Сайте.</li>
					</ul>
					<p>8.2. Отключение cookie может привести к некорректной работе отдельных функций Сайта, невозможности использования некоторых сервисов и ухудшению пользовательского опыта.</p>
					<h2 className={styles.subtitle}>9. Права пользователя и обращения</h2>
					<p>9.1. Пользователь вправе получить информацию об обработке его персональных данных, если такие данные обрабатываются Оператором в связи с использованием Сайта, а также реализовать иные права, предусмотренные законодательством Российской Федерации.</p>
					<p>9.2. Обращения, связанные с обработкой персональных данных и использованием cookie, направляются Оператору по контактным данным, указанным в разделе 1 настоящих Правил.</p>
					<p>9.3. Согласие на обработку данных, основанную на согласии, должно быть конкретным, предметным, информированным, сознательным и однозначным; это общее требование установлено ст. 9 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных».</p>
					<h2 className={styles.subtitle}>10.	Заключительные положения</h2>
					<p>10.1. Оператор вправе вносить изменения в настоящие Правила.</p>
					<p>10.2. Актуальная редакция Правил размещается на Сайте в открытом доступе. </p>
					<p>10.3. Во всем, что не урегулировано настоящими Правилами, Оператор руководствуется законодательством Российской Федерации и Политикой конфиденциальности ООО «ДАНТИСТ плюс» в отношении обработки персональных данных.</p>
				</div>
				<ScrollButton />
				<Cookie />
			</main>
			<Footer />
		</div>
	);
}

export default CookiePage;
